import { EButtonStyleType } from '@common/enums';
import { ThemeButtonProperties, ThemeButtonHoverProperties } from '@sites/site-theme/src/enums/button-properties.enum';

type ThemeStyleVariables<T extends string | number | symbol> = Record<T, string | string[]>;
type ThemeVariables<T extends string | number | symbol> = Partial<Record<EButtonStyleType, ThemeStyleVariables<T>>>;

export const THEME_BUTTONS_VARIABLES: ThemeVariables<ThemeButtonProperties> = {
    [EButtonStyleType.primary]: {
        [ThemeButtonProperties.borderRadius]: '--primary-button-border-radius',
        [ThemeButtonProperties.borderStyle]: '--primary-button-border-style',
        [ThemeButtonProperties.borderWidth]: '--primary-button-border-width',
        [ThemeButtonProperties.borderColor]: [
            '--primary-button-border-color-light',
            '--primary-button-border-color-dark',
        ],
        [ThemeButtonProperties.color]: ['--primary-button-color-light', '--primary-button-color-dark'],
        [ThemeButtonProperties.background]: ['--primary-button-background-light', '--primary-button-background-dark'],
    },
    [EButtonStyleType.secondary]: {
        [ThemeButtonProperties.borderRadius]: '--secondary-button-border-radius',
        [ThemeButtonProperties.borderStyle]: '--secondary-button-border-style',
        [ThemeButtonProperties.borderWidth]: '--secondary-button-border-width',
        [ThemeButtonProperties.borderColor]: [
            '--secondary-button-border-color-light',
            '--secondary-button-border-color-dark',
        ],
        [ThemeButtonProperties.color]: ['--secondary-button-color-light', '--secondary-button-color-dark'],
        [ThemeButtonProperties.background]: [
            '--secondary-button-background-light',
            '--secondary-button-background-dark',
        ],
    },
};

export const THEME_BUTTONS_HOVER_VARIABLES: ThemeVariables<ThemeButtonHoverProperties> = {
    [EButtonStyleType.primary]: {
        [ThemeButtonHoverProperties.opacity]: '--primary-button-hover-opacity',
        [ThemeButtonHoverProperties.shadow]: '--primary-button-hover-shadow',
        [ThemeButtonHoverProperties.color]: ['--primary-button-hover-color-light', '--primary-button-hover-color-dark'],
        [ThemeButtonHoverProperties.background]: [
            '--primary-button-hover-background-light',
            '--primary-button-hover-background-dark',
        ],
        [ThemeButtonHoverProperties.borderColor]: [
            '--primary-button-hover-border-color-light',
            '--primary-button-hover-border-color-dark',
        ],
    },
    [EButtonStyleType.secondary]: {
        [ThemeButtonHoverProperties.opacity]: '--secondary-button-hover-opacity',
        [ThemeButtonHoverProperties.shadow]: '--secondary-button-hover-shadow',
        [ThemeButtonHoverProperties.color]: [
            '--secondary-button-hover-color-light',
            '--secondary-button-hover-color-dark',
        ],
        [ThemeButtonHoverProperties.background]: [
            '--secondary-button-hover-background-light',
            '--secondary-button-hover-background-dark',
        ],
        [ThemeButtonHoverProperties.borderColor]: [
            '--secondary-button-hover-border-color-light',
            '--secondary-button-hover-border-color-dark',
        ],
    },
};
